<template>
  <div class="demo">
    <div>
      iconfont
      <SjIcon class="icon" iconClass="compagi_pre" theme="1"></SjIcon>
      <SjIcon
        class="icon"
        iconClass="compagi_pre"
        :size="30"
        theme="2"
      ></SjIcon>
      <SjIcon class="icon" iconClass="compagi_pre" theme="3"></SjIcon>
      <SjIcon class="icon" iconClass="compagi_pre" theme="4"></SjIcon>
    </div>
    <div>
      图片
      <SjIcon
        class="icon"
        :imgSrc="require('../../../assets/image/logo.png')"
      ></SjIcon>
      <SjIcon
        class="icon"
        theme="2"
        :imgSrc="require('../../../assets/image/logo.png')"
        :size="30"
      ></SjIcon>
      <SjIcon
        class="icon"
        theme="3"
        :imgSrc="require('../../../assets/image/logo.png')"
        :size="30"
        :iconSize="20"
      ></SjIcon>
      <SjIcon
        class="icon"
        theme="4"
        :imgSrc="require('../../../assets/image/logo.png')"
      ></SjIcon>
    </div>
    <div>
      disabled
      <SjIcon class="icon" iconClass="compagi_pre" disabled></SjIcon>
      <SjIcon
        class="icon"
        :imgSrc="require('../../../assets/image/logo.png')"
        disabled
      ></SjIcon>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped lang="less">
.demo {
  & > div {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .icon {
      margin-left: 20px;
    }
  }
}
</style>
